/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Shadow_LabelInputs */



/**
* | output |
* | --- |
* | "Shadow" |
*
* @param {Styles_Shadow_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_shadow_label = /** @type {((inputs?: Styles_Shadow_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Shadow_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ombre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schatten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ombra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тень")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sombra")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阴影")
	if (locale === "ja") return /** @type {LocalizedString} */ ("影")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छाया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sombra")
	return /** @type {LocalizedString} */ ("Shadow")
});